<template>
  <div>
    <!--
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "headingPlant">Confirm</md-dialog-title>
    
      <md-dialog-content >
      -->
         <popup-ui ref="popup">
            <div class="header">
              <label>{{ title }}</label>
            </div>
            <div class="msg-body">
               <span class="icons-center material-icons">warning</span><label>{{ message }}</label>
            </div>
            <div class="btns">
               <button class="cancel-btn" @click="doCancel">{{ cancelButton }}</button>
               <button class="ok-btn" @click="doConfirm">{{  okButton }}</button>
            </div>
         </popup-ui>
         <!--
      </md-dialog-content>
    </md-dialog>
  -->
  </div>
</template>


<style scoped>
  .btns {
     margin-top: 30px;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
  }
  .ok-btn {
   /*
     color: red;
     text-decoration: underline;
     line-height: 2.5rem;
     cursor: pointer;
   */
   /*position: absolute;*/
   top: 50%;
   background-color:#add8e6;
   color: black;
   border: none;
   border-radius:10px;
   font-weight: bold;
   width:80px;
   box-shadow: 0px 0px 2px 2px rgb(0,0,0);
   margin-left: 15px;
   margin-right:20%;
   margin-bottom: 10px;  
  }
  .ok-btn:hover {
    background-color: #002ead;
    transition: 0.7s;
    color: white;
  }
  .cancel-btn {
    /*
     padding: 0.5em 1em;
     background-color: #d5eae7;
     color: #35907f;
     border: 2px solid #0ec5a4;
     border-radius: 5px;
     font-weight: bold;
     font-size: 16px;
     text-transform: uppercase;
     cursor: pointer;
     */
    /* position: absolute;*/
   /*top: 50%;*/
   margin-left: 20%;
   background-color:#FFE0DF;
   color: black;
   font-weight: bold;
   border: none;
   border-radius:10px;
   width:80px;  
   box-shadow: 0px 0px 2px 2px rgb(0,0,0);  
   margin-bottom: 10px;  

  }
  .cancel-btn:hover {
    background-color: #AD7C7B;
    transition: 0.7s;
    color: white;
  }
  .header {
     margin-top: 0; 
     font-size:16px; 
     font-weight: bold;
     text-align: center;
     background-color: #5cb85c;
     color: white;
  }
  .msg-body {
     margin-top:15px;
     margin-right: 10px;
     font-weight: bold;
     text-align: center;
     font-size: 15px;
     color: red;
  }
</style>
<script>
  import PopupUi from './PopupUi.vue';

  export default {
    name: 'ConfirmAlert',

    components: { PopupUi },
    data: () => ({
       title: null,
       message: null,
       okButton: null,
       cancelButton: 'Go Back',
       resolvePromise: null,
       rejectPromise: null,      
    }),

    methods: {
       //showDialog(opts = {}) {
       show(opts = {}) {  
         this.title = opts.title;
         this.message = opts.message;
         this.okButton = opts.okButton;
         if (opts.cancelButton) {
            this.cancelButton = opts.cancelButton;
         }
         this.$refs.popup.open();
         return new Promise((resolve, reject) => {
            this.resolvePromise = resolve;
            this.rejectPromise = reject;
         })
       },
       doConfirm() {
          this.$refs.popup.close();
          this.resolvePromise(true);
       },
       doCancel() {
          this.$refs.popup.close();
          this.resolvePromise(false);
       },
    },
  };
</script>
